import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import { KeyValueGambit } from 'flarum/common/query/IGambit';
export default class TagGambit extends KeyValueGambit {
  constructor() {
    super(...arguments);
    _defineProperty(this, "predicates", true);
  }
  key() {
    return app.translator.trans('flarum-tags.lib.gambits.discussions.tag.key', {}, true);
  }
  hint() {
    return app.translator.trans('flarum-tags.lib.gambits.discussions.tag.hint', {}, true);
  }
  filterKey() {
    return 'tag';
  }
  gambitValueToFilterValue(value) {
    return [value];
  }
  fromFilter(value, negate) {
    let gambits = [];
    if (Array.isArray(value)) {
      gambits = value.map(value => this.fromFilter(value.toString(), negate));
    } else {
      return `${negate ? '-' : ''}${this.key()}:${this.filterValueToGambitValue(value)}`;
    }
    return gambits.join(' ');
  }
  filterValueToGambitValue(value) {
    return value;
  }
}
flarum.reg.add('flarum-tags', 'common/query/discussions/TagGambit', TagGambit);